/**
 * Created by stonewang on 2018/2/19.
 */
import React from 'react';
import {Card, Button, Avatar, Row, Col, Form, Upload, Icon, Input, message} from 'antd';
import {getUserDetail, modifyUserInfo} from '../../service/account';
import {uploadUrl} from '../../service/remark/file'
import {checkTelPhone, checkPhone} from '../../utils/regexp';
import {config} from '../../utils'
const FormItem = Form.Item;

class UserInfo extends React.Component {
	constructor(props) {
		super(props);
		this.userData = JSON.parse(window.localStorage.getItem('login_user_information') || '{}');
		this.state = {
			editFlag: false,
			detail: this.userData, //{},
			otherPhone: [],
			headPhoto: []
		};
		this.getData = this.getData.bind(this);
		this.addPhone = this.addPhone.bind(this);
		this.delPhone = this.delPhone.bind(this);
		this.saveHandle = this.saveHandle.bind(this);
		this.cancelHandle = this.cancelHandle.bind(this);
		this.editFlagChange = this.editFlagChange.bind(this);
	}

	componentDidMount() {
		// this.getData();
	}

	getData() {
		getUserDetail().then(res => {
			if (res.status) {
				//type 联系方式类型：1-手机；2-座机；3-Email；4-QQ；5-微信；6-钉钉
				let data = {};
				/*(res.data.dmsContactInfoList || []).forEach(x => {
					let key = ['', 'phone', 'tel', 'email', 'qq', 'wx', 'ding'];
					if (x.type !== 1) {
						data[key[x.type]] = x.content
					}
				})*/
				this.setState({
					...this.state,
					detail: {
						...res.data,
						...data,
						/*photoUrl: res.data.photoUrl ? config.server + res.data.photoUrl : '',*/
						mobile: (res.data.mobileTextList || [])[0] || ''
					},
					otherPhone: (res.data.mobileTextList || []).slice(1),
					headPhoto: res.data.photoUrl ? [{
						uid: -1,
						name: '',
						status: 'done',
						fileId: '',
						/*url: res.data.photoUrl ? config.server + res.data.photoUrl : '',*/
						url: res.data.photoUrl
					}] : [],
					editFlag: false
				})
			}
		})
	}

	editFlagChange() {
		this.setState({editFlag: !this.state.editFlag})
	}

	delPhone(index) {
		let {otherPhone} = this.state;
		otherPhone.splice(index, 1);
		this.setState({otherPhone});
	}

	addPhone() {
		let {otherPhone} = this.state;
		otherPhone.push('');
		this.setState({otherPhone});
	}

	cancelHandle() {
		this.props.form.resetFields();
		this.editFlagChange()
	}

	saveHandle() {
		const {detail} = this.state;
		const {validateFields, getFieldsValue} = this.props.form;
		validateFields((errors) => {
			if (errors) {
				return
			}
			const data = getFieldsValue();
			//type 联系方式类型：1-手机；2-座机；3-Email；4-QQ；5-微信；6-钉钉
			/*let dmsContactInfoList = [];
			Object.keys(data).forEach(x => {
				if (/phone_/.test(x) && data[x]) {
					dmsContactInfoList.push({content: data[x], type: 1});
					delete data[x]
				}
			})*/

			/*data.tel && dmsContactInfoList.push({content: data.tel, type: 2});
			delete data.tel;*/

			/*data.email && dmsContactInfoList.push({content: data.email, type: 3});
			delete data.email;*/
			//用户已上传图片
			/*if (data.upload && Array.isArray(data.upload) && data.upload.length && data.upload[0]['uid'] !== -1) {
				data['photoUrl'] = data.upload[0].fileUrl || '';
			}
			delete data.upload;*/
			//modifyUserInfo({id: detail.id, ...data, dmsContactInfoList}).then(res => {
			modifyUserInfo({id: detail.id, ...data}).then(res => {
				message[res.status ? 'success' : 'error'](res.message);
				/*if(res.status){
				 let loginData = JSON.parse(CookieUtils.get('login_data_information'));
				 login({
				 loginName: loginData.userName,
				 password: loginData.password,
				 }).then(result => {
				 /!*
				 user.orgId //当前组织
				 user.orgType //当前组织类型
				 user.loginOrgId //当前登录组织
				 user.roleType //当前登录组织类型
				 * *!/
				 let old_login_info = JSON.parse(window.localStorage.getItem('login_user_information'));
				 window.localStorage.setItem('login_user_information', JSON.stringify({
				 ...result.user,
				 currentOrgName: old_login_info.currentOrgName,
				 orgType: old_login_info.orgType,
				 OrgId: old_login_info.orgId,
				 loginOrgId: old_login_info.orgId
				 }));
				 loginInfoChange();
				 });
				 }else{
				 message.error(res.message);
				 }*/
				res.status && this.getData()
			})
		})
	}

	render() {
		const {editFlag, detail, otherPhone, headPhoto} = this.state;
		const {getFieldDecorator} = this.props.form;
		const formItemLayout = {
			labelCol: {span: 2},
			wrapperCol: {span: 10},
			colon: false,
			hasFeedback: true,
			className: 'dms-form-item'
		};
		var formatImg = function(img) {
			if(!img) {
				return require('../../assets/images/dms-man02.png');
			} else {
				if(img.indexOf('http')>-1 || img.indexOf('https')>-1){
					return img;
				} else {
					return config.mxm + img;
				}
			}
		}
		return <Card title="个人信息"
					 noHovering
					 extra={<div>
						 {/*{!editFlag && <Button onClick={this.editFlagChange}>编辑</Button>}
						  {editFlag && <Button onClick={this.cancelHandle}>取消</Button>}
						  {editFlag && <span>&nbsp;&nbsp;&nbsp;</span>}
						  {editFlag && <Button type="primary" onClick={this.saveHandle}>保存</Button>}*/}
					 </div>}>
			<Row gutter={16} style={{minHeight: '366px', display: editFlag ? 'none' : 'block'}}>
				<Col className="gutter-row" span={6}>
					<Avatar className="dms-avatar-lg" size="large"
							src={formatImg(detail.photoUrl)}/>
				</Col>
				<Col className="gutter-row" span={8}>
					<p className="text-list">姓名：{detail.roleName || detail.userName || '----'}</p>
					<p className="text-list">账号：{detail.loginName || '----'}</p>
					<p className="text-list">手机：{detail.phone || '----'}</p>
					{
						otherPhone.map((item, index) => (index + 1) % 2 !== 0 ?
							<p className="text-list" key={index}>手机：{item}</p> : null)
					}
				</Col>
				<Col className="gutter-row" span={10}>
					<p className="text-list">座机：{detail.telephone || '----'}</p>
					<p className="text-list">邮箱：{detail.email || '----'}</p>
					<p className="text-list">岗位：{detail.job ? detail.jobText : '----'}</p>
					{
						otherPhone.map((item, index) => (index + 1) % 2 === 0 ?
							<p className="text-list" key={index}>手机：{item}</p> : null)
					}
				</Col>
			</Row>
			{/*<div style={{display: editFlag ? 'block' : 'none'}}>
				<Form>
					<FormItem {...formItemLayout} label="个人头像">
						{getFieldDecorator('upload', {
							valuePropName: 'fileList',
							initialValue: headPhoto || [],
							getValueFromEvent(e){
								if (Array.isArray(e)) {
									return e;
								}
								if (e && e.file && e.file.status === 'error') {
									message.error(e.file.error.message)
								}
								if (e && e.file && e.file.status === 'done') {
									let list = e && e.fileList ? e.fileList.slice(-1) : [];
									if (list[0]) {
										list[0]['fileUrl'] = e.file.response.data.filePath
									}
									return list
								}
								return e && e.fileList;
							}
						})(
							<Upload className="cor-fileList circle"
									headers={{"corTicket": window.localStorage.getItem('cor-ticket') || ''}} name="logo"
									action={uploadUrl} data={{source: 'dms'}} listType="picture">
								<Button>&nbsp;&nbsp;上传&nbsp;&nbsp;</Button>
							</Upload>
						)}
					</FormItem>
					<hr className="overEdge"/>
					<FormItem {...formItemLayout} label="姓名">
						<Input disabled value={detail.name}/>
					</FormItem>
					<FormItem {...formItemLayout} label="账号">
						<Input disabled value={detail.account}/>
					</FormItem>
					<FormItem {...formItemLayout}
							  wrapperCol={{span: 14}}
							  label="手机">
						{getFieldDecorator('mobile', {
							initialValue: detail.mobile || '',
							rules: [
								{
									required: true,
									message: '请输入手机'
								},
								{
									validator: checkPhone
								}
							],
						})(<Input placeholder="请输入手机" style={{width: '71.14%'}}/>)}
						&nbsp;&nbsp;&nbsp;&nbsp;
						<Button type="primary" onClick={this.addPhone}><Icon type="plus"/> 添加手机号</Button>
					</FormItem>
					{
						otherPhone.map((item, index) => <FormItem {...formItemLayout}
																  wrapperCol={{span: 14}}
																  key={index}
																  label={<span>&nbsp;</span>}>
							{getFieldDecorator(`phone_${index + 1}`, {
								initialValue: item || '',
								rules: [
									{
										validator: checkPhone
									}
								],
							})(<Input placeholder="请输入手机" style={{width: '71.14%'}}/>)}
							&nbsp;&nbsp;&nbsp;&nbsp;
							<Button onClick={this.delPhone.bind(this, index)}><Icon type="close"/></Button>
						</FormItem>)
					}
					<FormItem {...formItemLayout} label="座机">
						{getFieldDecorator('telephone', {
							initialValue: detail.telephone || '',
							rules: [
								{
									validator: checkTelPhone
								},
								{
									max: 20,
									message: '最多可输入20个字符'
								}
							],
						})(<Input placeholder="请输入座机"/>)}
					</FormItem>
					<FormItem {...formItemLayout} label="邮箱">
						{getFieldDecorator('email', {
							initialValue: detail.email || '',
							rules: [
								{
									required: true,
									message: '请输入邮箱'
								},
								{
									type: 'email',
									message: '请输入正确的邮箱地址'
								},
								{
									max: 50,
									message: '最多可输入50个字符'
								}
							],
						})(<Input placeholder="请输入邮箱"/>)}
					</FormItem>
					<FormItem {...formItemLayout} label="岗位">
						<Input disabled value={detail.job || ''}/>
					</FormItem>
				</Form>
			</div>*/}
		</Card>
	}
}
export default Form.create()(UserInfo)



// WEBPACK FOOTER //
// ./src/mall/userCenter/userInfo.js